import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { StatCard } from "components/common";
import NumberUtils from "util/NumberUtils";
import { distinctValues, shareOfTotal, tokensPerRun } from "ai-management/token-usage/usageSummary";
const Tiles = styled.section(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: ${theme.spacings.md};

    @media (max-width: ${theme.breakpoints.max.md}) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  `
);
const countOf = (count, noun) => i18n.t(`usage_stats.${noun}`, {
  ns: "enterprise_ai",
  count,
  formatted: NumberUtils.formatNumber(count)
});
const scopeText = ({ rows, totals }) => [
  countOf(totals.runs, "runs"),
  countOf(distinctValues(rows, "feature_id").length, "features"),
  countOf(distinctValues(rows, "model").length, "models")
].join(" \xB7 ");
const shareText = (share) => share === void 0 ? void 0 : i18n.t("usage_stats.of_total", { ns: "enterprise_ai", share: NumberUtils.formatPercentage(share) });
const UsageStats = ({ usage }) => {
  const { t } = useTranslation("enterprise_ai");
  const { totals } = usage;
  return /* @__PURE__ */ React.createElement(Tiles, { "aria-label": t("usage_stats.aria_label") }, /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "primary",
      label: t("usage_stats.total_tokens"),
      value: NumberUtils.formatNumber(totals.tokens.total_tokens),
      subValue: t("usage_stats.across", { scope: scopeText(usage) })
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "info",
      label: t("usage_stats.input_tokens"),
      value: NumberUtils.formatNumber(totals.tokens.input_tokens),
      subValue: shareText(shareOfTotal(totals.tokens.input_tokens, totals)),
      helpText: t("usage_stats.input_tokens_help")
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "success",
      label: t("usage_stats.output_tokens"),
      value: NumberUtils.formatNumber(totals.tokens.output_tokens),
      subValue: shareText(shareOfTotal(totals.tokens.output_tokens, totals)),
      helpText: t("usage_stats.output_tokens_help")
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      variant: "gray",
      label: t("usage_stats.avg_per_run"),
      value: NumberUtils.formatNumber(tokensPerRun(totals.tokens.total_tokens, totals.runs)),
      subValue: t("usage_stats.tokens_per_run")
    }
  ));
};
export default UsageStats;
